/** Comma / whitespace–separated voucher UUIDs from the promo tester form or URL */
export function parsePromoTesterVoucherIds(raw?: string | null): Array<string> | undefined {
  if (!raw?.trim()) {
    return undefined;
  }
  const ids = raw
    .split(/[\s,]+/)
    .map((s) => s.trim())
    .filter(Boolean);
  return ids.length ? ids : undefined;
}
